module.exports = __webpack_public_path__ + "static/media/profile-pic.0634c966.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bot_gif/profile-pic.png
// module id = 572
// module chunks = 0